import React from 'react';

const UserSVG = ({ scale, opacity, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={"22"} height={"22"} viewBox="0 0 22 22" style={{
      scale: scale ? scale : 1,
      zoom: scale ? scale : 1
    }}>
      <g id="Group_16264" data-name="Group 16264" transform="translate(-2 -2)" opacity={opacity || "0.5"}>
        <g id="Group_16263" data-name="Group 16263" transform="translate(2 2)">
          <circle id="Ellipse_487" data-name="Ellipse 487" cx="1" cy="1" r="1" transform="translate(10 7)" fill={fill || "#fff"} />
          <path id="Path_18975" data-name="Path 18975" d="M9.184,14.2h6.2a3.281,3.281,0,0,0-6.2,0Z" transform="translate(-1.282 -1)" fill="#fff" />
          <path id="Path_18976" data-name="Path 18976" d="M20.7,2H5.3A3.3,3.3,0,0,0,2,5.3v9.9H7.611a5.494,5.494,0,0,1,2.661-3.646,3.3,3.3,0,1,1,5.456,0A5.5,5.5,0,0,1,18.389,15.2H24V5.3A3.3,3.3,0,0,0,20.7,2Z" transform="translate(-2 -2)" fill="#fff" />
          <path id="Path_18977" data-name="Path 18977" d="M2,19.3a3.3,3.3,0,0,0,3.3,3.3H20.7A3.3,3.3,0,0,0,24,19.3V16H2Zm5.5-2.2h11v2.2H7.5Z" transform="translate(-2 -0.6)" fill="#fff" />
        </g>
      </g>
    </svg>
  );
};

export default UserSVG;
